const menuListManager = [
  {
    path: 'menu-list/:type',
    name: 'MenuList',
    component: () => import('@/views/wxapp/customer-manager/menuList'),
    meta: {
      title: '列表'
    },
    props: true
  }
]
export default menuListManager
